<template>
  <v-container>
      
      <v-layout row>
        <v-flex xs6>
            <v-card dark tile color="indigo darken-4">
                <v-card-text>
                    <v-layout row>
                        <h3 class="bolder"><b>Nuevo préstamo de libro</b> - {{libro.titulo}}</h3>
                    </v-layout>
                    <v-layout row>
                        <h4><b>Autores:</b> - {{libro.autores_nombres}}</h4>
                    </v-layout>
                    <v-layout row>
                        <v-flex xs4>
                            <p><b>ISBN:</b> {{libro.isbn}}</p>
                        </v-flex>
                        <v-flex xs4>
                            <p><b>Código:</b> {{libro.codigo_inventario}}</p>
                        </v-flex>
                        <v-flex xs4>
                            <p><b>Categoría:</b> {{libro.categoria.nombre_categoria}}</p>
                        </v-flex>
                        <v-flex xs4>
                            <b><p>{{libro.edicion.descripcion}}</p></b>
                        </v-flex>
                    </v-layout>
                    <v-layout row>
                        <h4><b>Editorial:</b> - {{libro.editorial.nombre}}</h4>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
      <v-flex xs6>
          <v-layout row>
              <v-flex>
                <v-card tile color="grey lighten-4 light" style="height:164px;">
                    <v-card-text>
                        <v-form ref="form" v-model="valid" lazy-validation>
                                <v-text-field
                                    id="testing"
                                    name="input-1"
                                    label="Buscar estudiante por número carné"
                                    :rules="carneRules"
                                    required
                                    type="number"
                                    >
                                </v-text-field>
                                <v-btn color="primary"
                                @click="buscarAlumno"
                                >
                                    Buscar
                                </v-btn>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
      </v-flex>
      </v-layout>
      <v-layout row>
              <v-flex>
                <v-card v-show="encontrado" tile color="white light">
                    <v-card-text center>
                        <v-layout row>
                             <v-flex xs4>
                                <h3>El prestamo se realizará a: {{alumno}}</h3>
                            </v-flex>
                            <v-flex xs2>
                                <v-btn dark color="green" @click="registrarPrestamo">
                                    Registrar Préstamo
                                </v-btn>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    

  </v-container>
</template>


<script>
//Flujo de funcionamiento, el usuario ingresa los datos del libro seleccionando autores, categoría, etc, 
//luego agrega al listado la cantidad y edición con la que cuentan del libro y luego guarda
import { debuglog } from "util";
export default {
  data: () => ({
    valid: true,
    libro:{},
    carne: "",
    alumno: "Ramón López",
    carneRules: [
        v => !!v || 'Ingrese el número de carné por favor',
        v => (v && v.length >= 8) || 'El carné debe tener al menos 8 números'
    ],

  }),
 
  created() {
    this.libro = this.$route.params.libro;
    console.log(this.libro);
  },

    

  methods: {
    buscarAlumno () {
        if (this.$refs.form.validate()) {
          // Native form submission is not yet supported
          alert("Validado con éxito")
        }
        else{
            alert("Por favor ingrese el número de carné para realizar la búsqueda")
        }
    }
  }
};
</script>
<style>
    .bolder{
        font-weight: 800;
    }
</style>